import "./_historique.scss";

import cx from "classnames";

import {OffreType} from "@/ts/interface/offres";

function HistoriqueBloc({
  id,
  label,

  type,

  children,
}: {
  id?: number;
  label?: string;

  type: OffreType;
  children?: React.ReactNode;
}): JSX.Element {
  let categorie: string = "";

  switch (type) {
    case "massification":
      categorie = "Engagement Massification: ";
      break;
    case "operationCommerciale":
      categorie = "Opération commerciale";
      break;
    default:
      break;
  }

  return (
    <article className={cx("historique", `historique-${type}`)}>
      <div className="historique-header">
        <p className="historique-id">{`${categorie}${id || ""}`}</p>
        <p className="historique-label">{label}</p>
      </div>
      <div>{children}</div>
    </article>
  );
}

export default HistoriqueBloc;
